import { useMutation } from '@tanstack/react-query';
import { fetchCurrentMeta, processMeta, uploadMeta } from '@/services/metaProcessingApi';
import { queryKeys } from '@/services/queryKeys';
import { GeneratedMeta, MetaProcessRequest } from '@/types/metaProcessing';

/**
 * Loads the current meta and the processed meta together, so the UI can compare them.
 * Both read the same S3 file independently, so they run in parallel; if either fails the
 * whole generate fails and nothing is shown half-loaded.
 *
 * The mutation key lets other components read "is a generate in flight" via useIsMutating.
 */
export const useGenerateMetaMutation = (onSuccess: (result: GeneratedMeta) => void) =>
  useMutation({
    mutationKey: queryKeys.generateMeta,
    mutationFn: async (request: MetaProcessRequest): Promise<GeneratedMeta> => {
      const [current, processed] = await Promise.all([
        fetchCurrentMeta(request.userEmail, request.groupId),
        processMeta(request),
      ]);
      return { current, processed };
    },
    onSuccess,
  });

/** Overwrites the group's meta in S3 (the QA dashboards read it) with the reviewed meta. */
export const usePublishMetaMutation = () => useMutation({ mutationFn: uploadMeta });
